import { render, staticRenderFns } from "./BrandFamily.vue?vue&type=template&id=4e7251f5&scoped=true&"
import script from "./BrandFamily.vue?vue&type=script&lang=js&"
export * from "./BrandFamily.vue?vue&type=script&lang=js&"
import style0 from "./BrandFamily.vue?vue&type=style&index=0&id=4e7251f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7251f5",
  null
  
)

export default component.exports